import { Box, Image } from '@frontend/ui-library';
import cx from 'classnames';

import styles from './CountryFlag.module.css';

interface CountryFlagProps {
  className?: string;
  countryCode: string;
  width?: number;
}

export default function CountryFlag({
  className,
  countryCode,
  width = 32,
}: CountryFlagProps): JSX.Element {
  const ratio = 4 / 3;

  const height = width / ratio;

  return (
    <Box className={cx(styles['base'], className)} style={{ width, height }}>
      <Image src={`/assets/countryFlags/${countryCode.toLowerCase()}.svg`} />
    </Box>
  );
}
